import { createSelector } from "@ngrx/store";
import { IAppState, IRemoteXPACPortalState } from "src/app/utils/interfaces/store.interfaces";

export const selectApp = (state: IRemoteXPACPortalState) => state.app;

export const selectErrorEvent = createSelector(
  selectApp,
  (state: IAppState) => state.errorEvent
);